import React from 'react';
import styled, { css } from 'styled-components';

const Box = ({
  selected,
  className,
  title,
  children,
  style,
  type = 'default',
  onClick,
}: {
  selected?: boolean;
  title?: string;
  className?: string;
  children?: React.ReactNode;
  onClick?: () => void;
  style?: React.CSSProperties;
  type?: 'default' | 'clean';
}) => {
  return (
    <Container
      selected={selected}
      onClick={onClick}
      className={className}
      type={type}
      style={style}
    >
      <Title selected={selected}>{title}</Title>
      {children}
    </Container>
  );
};

const Container = styled.div<{ selected?: boolean; type?: 'default' | 'clean' }>`
  cursor: pointer;
  box-shadow: ${({ type }) => (type === 'clean' ? 'none' : '0px 0px 10px 4px rgba(0, 0, 0, 0.03)')};
  width: 100%;
  padding: 10px 20px;
  border: 2px solid transparent;
  /* transition: all 0.1s ease; */
  background-color: #fff;
  border-radius: var(--border-radius);
  border: ${({ type }) => (type === 'default' ? 'none' : '1px solid #efefef')};
  color: #000;
  border: 2px solid transparent;

  ${({ selected }) =>
    selected &&
    css`
      border: 2px solid var(--point-color);
      box-shadow: none;
    `}
`;

const Title = styled.div<{ selected?: boolean }>`
  font-size: 16px;
  font-weight: 400;
  ${({ selected }) =>
    selected &&
    css`
      font-weight: 700;
    `}
`;

export default Box;
